import flatten from 'lodash.flatten';

const getVoucherFromItemId = (vouchers, itemId) => {
  const items = flatten(vouchers.map(({ categoryItems }) => categoryItems));

  return items.find((item) => item.itemId === itemId);
};

export default getVoucherFromItemId;
